"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const React = require("react");
const Store_1 = require("../Store");
const mobx_1 = require("mobx");
let SearchPagination = class SearchPagination extends React.Component {
    get currentPage() {
        return Store_1.default.skip / Store_1.default.take + 1;
    }
    get numberOfPages() {
        return Math.ceil(Store_1.default.results.total / Store_1.default.take);
    }
    render() {
        let pagination = [];
        for (var i = 1; i <= this.numberOfPages; i++) {
            pagination.push(React.createElement("span", { key: i, className: this.currentPage === i ? "search-pagination-active" : "", onClick: Store_1.default.ChangePage.bind(this, i) },
                " ",
                i));
        }
        return (React.createElement("div", { className: "search-pagination" },
            this.currentPage > 1 && React.createElement("span", { onClick: (e) => Store_1.default.ChangePage(this.currentPage - 1) }, "\u00AB"),
            pagination,
            this.currentPage < (this.numberOfPages) && React.createElement("span", { onClick: (e) => Store_1.default.ChangePage(this.currentPage + 1) }, "\u00BB")));
    }
};
__decorate([
    mobx_1.computed
], SearchPagination.prototype, "currentPage", null);
__decorate([
    mobx_1.computed
], SearchPagination.prototype, "numberOfPages", null);
SearchPagination = __decorate([
    mobx_react_1.observer
], SearchPagination);
exports.default = SearchPagination;
